import React from 'react';
import Notification from '../../Shared/Notifications';
import { Stepper } from 'react-form-stepper';
import { StepOne } from './steps/one';
import { StepTwo } from './steps/two';
import { StepTrhee } from './steps/trhee';
import { StepFour } from './steps/four';
import { StepFive } from './steps/five';
import ClipLoader from "react-spinners/ClipLoader";
import { createPenalitie } from './services/penalities';
import { STEP_ONE, STEP_TWO, STEP_TRHEE, STEP_FOUR, STEP_FIVE } from '../../Shared/Constants';
import { getAllLists } from './services/penalities';

export default class NewPenalitie extends React.Component {

    steps = [
        {
            label:'Datos Personales'
        },
        {
            label:'Datos del Vehiculo'
        },
        /*{
            label:'Grua'
        },*/
        {
            label:'Multa'
        },
        {
            label:'Datos Finales'
        }
    ]

    constructor(props){
        super(props)
        this.state = {
            activeStep:1,
            stepOne:STEP_ONE,
            stepTwo:STEP_TWO,
            stepThree:STEP_TRHEE,
            stepFour:STEP_FOUR,
            stepFive:STEP_FIVE,
            cranes: [],
            penalities:[],
            loadingCranes:true,
            loadingPenalities:true,
            brands:[],
            models:[],
            colors:[],
            sector:[],
            typeVehicles:[],
            notification:false,
        };
    }

    componentDidMount = () => {
        
        getAllLists({id:0}).then((result) => {
            this.setState({
                    cranes:result.data.data[0].towTruck, 
                    penalities:result.data.data[0].concept, 
                    brands:result.data.data[0].brand,
                    models:result.data.data[0].model,
                    colors:result.data.data[0].color,
                    sector:result.data.data[0].sector,
                    typeVehicles:result.data.data[0].typeVehicle,
                    loadingPenalities:false,
                    loadingCranes:false,
                });
        }).catch((error) => console.log(error))
    }

    

    updateStepData(step, data) { 
        if(step === 'one') { 
            this.setState({stepOne:data});
        }
        if(step === 'two') {
            this.setState({stepTwo:data});
        }
        if(step === 'trhee') {
            this.setState({stepTrhee:data});
        }
        if(step === 'four') {
            this.setState({stepFour:data});
        }
        if(step === 'five') {
            this.setState({stepFive:data});
        }
    }

    stepOne = () => {
        return(
            <StepOne updateStepData={(step, data) => {this.updateStepData(step, data)}} data={this.state.stepOne}/>
        )
    }

    stepTwo = () => {
        return(
            <StepTwo 
                updateStepData={(step, data) => {this.updateStepData(step, data)}} 
                data={this.state.stepTwo}
                brands={this.state.brands}
                models={this.state.models}
                colors={this.state.colors}
                typeVehicles={this.state.typeVehicles}
                />
        )
    }

    stepTrhee = () => {
        if(this.state.loadingCranes){
            return(
            <div className="flex justify-center items-center">
                <ClipLoader
                    color={'#000000'}
                    loading={true}
                    size={50}/>
            </div>
            )
        }else{
            return(
                <StepTrhee 
                    updateStepData={(step, data) => {this.updateStepData(step, data)}} 
                    cranes={this.state.cranes} 
                    data={this.state.stepThree}
                />
            )
        }

    }

    stepFour = () => {
        if(this.state.loadingPenalities){
            return(
                <div className="flex justify-center items-center">
                    <ClipLoader
                        color={'#000000'}
                        loading={true}
                        size={50}/>
                </div>
            )
        }else{
            return(
                <StepFour 
                    updateStepData={(step, data) => {this.updateStepData(step, data)}} 
                    penalities={this.state.penalities} 
                    data={this.state.stepFour}
                />
            )
        }
    }

    stepFive = () => {
        return(
            <StepFive updateStepData={(step, data) => {this.updateStepData(step, data)}} data={this.state.stepFive} sector={this.state.sector}/>
        )
    }

    nexStep = ( ) => {
        if(this.state.activeStep >= 1 && this.state.activeStep < 4) {
            this.setState({activeStep: this.state.activeStep + 1})
        }
    }

    backStep = () => {
        if(this.state.activeStep !== 1){
            this.setState({activeStep: this.state.activeStep - 1})
        }
    }

    endCreation = () => {

        this.setState({loadingForm:true})
        /* datos para la multa */
        const body = {
            /* FIRST STEP */
            idOfficial:0,
            idSector: this.state.stepFive.sector ? parseInt(this.state.stepFive.sector) : 0,
            id: 0,
            identification: this.state.stepOne.identification,
            firstName: this.state.stepOne.firstName,
            middleName: this.state.stepOne.secondName,
            firstLastName: this.state.stepOne.firstLastName,
            middleLastName: this.state.stepOne.secondLastName,
            gender: this.state.stepOne.gender,
            phone: [this.state.stepOne.phone],
            email: this.state.stepOne.email.toLowerCase(),
            address: this.state.stepOne.direction,
            /* SECOND STEP */
            idVehicle:0,
            idBrand:0,
            idColor:this.state.stepTwo.color ? parseInt(this.state.stepTwo.color) : 0,
            idModel:0,
            numberPlate:this.state.stepTwo.plate,
            brand: this.state.stepTwo.brand,
            color: '',
            model: this.state.stepTwo.model,
            nYear: this.state.stepTwo.year ? parseInt(this.state.stepTwo.year) : 0,
            serial: this.state.stepTwo.serial,
            idParking: this.state.stepTwo.idParking ? 1 : 0,
            /* THIRT STEP */
            idTowing: this.state.stepTrhee.idTowing,
            idTowTruck: this.state.stepTrhee.crane,
            identificationTT: '',
            numberPlateTT: '',
            nameTT: '',
            phoneTT: [],
            emailTT: '',
            addressTT: '',
            /* LAST  STEP */
            spot: this.state.stepFive.spot,
            idSubType: parseInt(this.state.stepFive.idSubType),
            comment: this.state.stepFive.detail,
            concept: this.getFormatedConcepts(),
            signature: '',
            refusedToSign: false,
            idTypeFine:1,

            /* last items */
            idTypeVehicle: this.state.stepTwo.idTypeVehicle,
            latitude: 10.49581, // for now default set 
            longitude: -66.85367, // for now default set 
            image:[]
        }
        createPenalitie(body).then((result) => {
            if(result && result.status === 200) {
                this.setState({renderNotification:true})
                setTimeout(() => {
                    this.setState({notification:false});
                    this.setState({loadingForm:false});
                    window.history.back()
                }, 3000)
            }
        }).catch((error) => console.log(error ))

    }


    getFormatedConcepts = () => {
        return this.state.stepFour.penalities.map((penality) => {
            return {
                idConcept: penality.id,
                value: penality.value,
            }
        })
    }

    renderNotification = () => {
        return(
            <Notification 
                show={this.state.notification}
                title={'Datos almacenados'}
                subtitle={'Sus datos fueron almacenados correctamente.'}
            />
        )
    }

    cancelPenalitie = () => {
        if(window.confirm('¿Seguro que deseas cancelar la multa?')) {
            window.history.back()
        }
    }

    render() {
        return (
            <div>
                <Stepper
                    styleConfig={{activeBgColor:'#D3D3D3', completedBgColor:'#D3D3D3'}}
                    steps={this.steps}
                    activeStep={this.state.activeStep}
                    />
                    <div style={{alignItems:'center'}}>
                        {
                            this.state.activeStep === 1 && !this.state.loadingForm? 
                                this.stepOne()
                            :
                            this.state.activeStep === 2 && !this.state.loadingForm? 
                                this.stepTwo()
                            :
                            this.state.activeStep === 3 && !this.state.loadingForm? 
                                this.stepFour()
                            :
                            this.state.activeStep === 4 && !this.state.loadingForm? 
                                this.stepFive()
                            :
                            /*this.state.activeStep === 5 && !this.state.loadingForm? 
                                this.stepFive()
                            :*/
                            this.state.loadingForm?
                                <center>
                                    <ClipLoader
                                        color={'gray'}
                                        loading={true}
                                        size={50}
                                        aria-label="Loading Spinner"
                                        data-testid="loader"/>
                                </center>
                            : null
                        }
                    </div>

                    <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
                        {
                            this.state.activeStep === 1 ?
                                <button
                                    onClick={() => this.cancelPenalitie()}
                                    type="button"
                                    className="rounded-full bg-white px-3.5 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                >
                                    Cancelar Multa
                                </button>
                            :
                                <button
                                    onClick={() => this.backStep()}
                                    type="button"
                                    className="rounded-full bg-white px-3.5 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                >
                                    Volver
                                </button>
                        }
                        {
                            this.state.activeStep !== 4 ?
                                <button
                                    onClick={() => this.nexStep()}
                                    type="button"
                                    className="rounded-full bg-white px-3.5 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                >
                                    Siguiente
                                </button>
                                :
                                <button
                                    onClick={() => this.endCreation()}
                                    type="button"
                                    className="rounded-full bg-white px-3.5 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                >
                                    Finalizar Multa
                                </button>
                        }
                        
                    </div>
                    {this.renderNotification()}
            </div>
        )
    }
}